/* myar-silicone (2026-10-16): caliper covers need high-temp silicone (not included) -> offer it in the cart drawer */
(function () {
  var SIL = [
    { h: 'temperature-rtv-silicone-gasket-maker-black-500-f-260-c-sealant-caliper-cover-adhesive', c: 'black' },
    { h: 'temperature-rtv-silicone-gasket-maker-red-500-f-260-c-sealant-caliper-cover-adhesive', c: 'red' }
  ];
  var lang = (document.documentElement.lang || 'en').slice(0, 2);
  var T = {
    en: { t: 'Needed for installation', d: 'Caliper covers are mounted with high-temperature silicone – it is not included in the set.', add: 'Add', black: 'Black', red: 'Red' },
    de: { t: 'Für die Montage benötigt', d: 'Bremssattelabdeckungen werden mit hitzebeständigem Silikon montiert – es ist nicht im Set enthalten.', add: 'Hinzufügen', black: 'Schwarz', red: 'Rot' },
    fr: { t: 'Nécessaire pour le montage', d: 'Les caches d’étriers se fixent avec du silicone haute température – il n’est pas inclus dans le kit.', add: 'Ajouter', black: 'Noir', red: 'Rouge' },
    it: { t: 'Necessario per il montaggio', d: 'I copripinze si montano con silicone per alte temperature – non è incluso nel set.', add: 'Aggiungi', black: 'Nero', red: 'Rosso' }
  }[lang] || null;
  if (!T) T = { t: 'Needed for installation', d: 'Caliper covers are mounted with high-temperature silicone – it is not included in the set.', add: 'Add', black: 'Black', red: 'Red' };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency) || { active: 'EUR', rate: '1.0' };
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur.active }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + cur.active; }
  }
  var css = '.myar-sil{margin:12px 0 4px;padding:12px;border:1px solid #c9a45c;border-radius:8px;background:#fffaf0;font-size:13px;line-height:1.35;color:#222}' +
    '.myar-sil__t{font-weight:700;font-size:14px;margin-bottom:3px}.myar-sil__d{color:#555;margin-bottom:10px}' +
    '.myar-sil__o{display:flex;align-items:center;gap:10px;padding:6px 0;border-top:1px solid #f0e6cf}' +
    '.myar-sil__o img{width:46px;height:46px;object-fit:contain;border-radius:4px;background:#fff;flex:0 0 46px}' +
    '.myar-sil__n{flex:1}.myar-sil__n b{display:block;font-size:13px}' +
    '.myar-sil__b{border:0;background:#141414;color:#fff;border-radius:6px;padding:8px 14px;font-weight:600;font-size:13px;cursor:pointer;white-space:nowrap}' +
    '.myar-sil__b[disabled]{opacity:.5;cursor:default}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var state = null, prods = null, busy = false;
  function loadProds() {
    if (prods) return Promise.resolve(prods);
    return Promise.all(SIL.map(function (s) {
      return fetch(root + 'products/' + s.h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      prods = [];
      list.forEach(function (p, i) {
        if (!p || !p.variants || !p.variants[0] || !p.variants[0].available) return;
        prods.push({ id: p.variants[0].id, price: p.variants[0].price, img: p.featured_image, c: SIL[i].c });
      });
      return prods;
    });
  }
  function check() {
    if (busy) return; busy = true;
    fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var items = c.items || [];
      var needs = items.some(function (i) { return /caliper/.test(i.handle || '') && !/sticker|decal/.test(i.handle || ''); });
      var has = items.some(function (i) { return /silicone-gasket/.test(i.handle || ''); });
      state = needs && !has;
      return state ? loadProds() : null;
    }).catch(function () {}).then(function () { busy = false; render(); });
  }
  function render() {
    var box = document.querySelector('.scd__items');
    var old = document.querySelector('.myar-sil');
    if (!state || !prods || !prods.length || !box) { if (old) old.remove(); return; }
    if (old && old.parentNode === box) return;
    if (old) old.remove();
    var d = document.createElement('div'); d.className = 'myar-sil';
    var html = '<div class="myar-sil__t">🔧 ' + T.t + '</div><div class="myar-sil__d">' + T.d + '</div>';
    prods.forEach(function (p) {
      html += '<div class="myar-sil__o">' + (p.img ? '<img src="' + p.img + (p.img.indexOf('?') < 0 ? '?' : '&') + 'width=100" alt="" loading="lazy">' : '') +
        '<div class="myar-sil__n"><b>' + T[p.c] + '</b>' + money(p.price) + '</div>' +
        '<button type="button" class="myar-sil__b" data-v="' + p.id + '">' + T.add + '</button></div>';
    });
    d.innerHTML = html;
    box.appendChild(d);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.myar-sil__b'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.dataset.v, quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) throw 0; state = false; render();
        var C = window.MinimogTheme && MinimogTheme.Cart;
        if (!C || !C.renderNewCart) { location.reload(); return; }
        return Promise.resolve(C.refreshCart && C.refreshCart())
          .then(function () { return C.renderNewCart(); })
          .then(function () { try { if (C.updateCartCount) C.updateCartCount(C.cart); } catch (x) {} })
          .catch(function () { location.reload(); });
      })
      .catch(function () { b.disabled = false; });
  });
  var of = window.fetch;
  window.fetch = function (u) {
    var p = of.apply(this, arguments);
    try { var s = typeof u === 'string' ? u : (u && u.url) || ''; if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { setTimeout(check, 350); }); } catch (e) {}
    return p;
  };
  // the theme re-renders the drawer; put the block back from the cached state (no extra requests)
  setInterval(function () { if (state) render(); }, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();
